import type { DependencyList, EffectCallback } from "react";
import { useEffect, useRef } from "react";

/**
 * Like {@link React.useEffect}, but it doesn't run when the component first mounts. It only
 * runs when a dependency changes.
 *
 * @see {@link React.useEffect}
 */
export default function useEffectAfterMount(effect: EffectCallback, deps: DependencyList) {
	const hasRun = useRef(false);
	useEffect(() => {
		if (!hasRun.current) {
			hasRun.current = true;
			return undefined;
		} else {
			return effect();
		}
	}, deps); // eslint-disable-line react-hooks/exhaustive-deps
	// ESLint isn't smart enough to realize we're just wrapping useEffect, so using `deps` here
	// makes sense. By configuring the `exhaustive-deps` rule to check this hook, we ensure that
	// the values passed into it are correct.
}
